<div class="ir-area ir-mask th-mask" *ngIf="point">
  <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'points.make-not-available' | translate: point }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'points.reason' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <p class="ir-required th-required" [class.visible]="!isReasonValid()">
                  <span>{{ 'common.required' | translate }}</span>
                </p>
                <input type="hidden" name="reason" class="ir-form-set" formControlName="reason" />
                <div class="ir-line ir-select th-select" (click)="openReasonsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.reason.value != -1
                        ? (editForm.controls.reason.value | notapplicablereasonpipe)
                        : ('points.select-reason' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'points.comment' | translate }} *</span>
        </h2>
        <div class="ir-form-group">
          <p
            *ngIf="!editForm.controls.comment.valid && editForm.controls.comment.touched"
            class="ir-required th-required visible"
          >
            <span>{{ 'common.required' | translate }}</span>
          </p>
          <textarea formControlName="comment" rows="4" placeholder="Details" class="ir-form-set"></textarea>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block ir-txt--right"
            type="submit"
            [ngClass]="editForm.valid ? 'th-btn-modal--action' : 'th-btn-disabled'"
            [disabled]="!editForm.valid"
            *ngIf="!processing"
          >
            <span>{{ 'points.make-not-applicable' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
